import { useState } from 'react';
import { faqData } from '@/constants';
import './FAQComponent.scss';

const FAQComponent = () => {
    const [openFaqs, setOpenFaqs] = useState<number[]>([]);

    const handleFaqToggle = (index: number) => {
        const isOpen = openFaqs.includes(index);
        if (isOpen) {
            setOpenFaqs([]); // Close the open tab
        } else {
            setOpenFaqs([index]); // Open only this tab, close others
        }
    };

    return (
        <div className="faq-section">
            <div className="faq-header">
                <h2>Pricing & Plans – FAQ</h2>
            </div>
            
            <div className="faq-content">
                {faqData.faqs.map((faq, index) => (
                    <div key={faq.id} className="faq-item">
                        <div 
                            className="faq-question" 
                            onClick={() => handleFaqToggle(index)}
                        >
                            <h3>{faq.question}</h3>
                            <span className={`faq-icon ${openFaqs.includes(index) ? 'open' : ''}`}>
                                {openFaqs.includes(index) ? '−' : '+'}
                            </span>
                        </div>
                        <div className={`faq-answer ${openFaqs.includes(index) ? 'open' : ''}`}>
                            <div className="faq-answer-text">
                                {faq.answer.split('\n').map((line, lineIndex) => (
                                    line.startsWith('•') ? (
                                        <div key={lineIndex} className="faq-bullet-point">{line}</div>
                                    ) : line.trim() ? (
                                        <div key={lineIndex}>{line}</div>
                                    ) : null
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQComponent;
